(() => {
  if (customElements.get('vallario-creator-loop')) return;
  customElements.define('vallario-creator-loop', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.button = this.querySelector('[data-creator-toggle]');
      if (!this.video || !this.button) return;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.manualPaused = false;
      this.inView = false;
      this.load = () => {
        const source = this.video.querySelector('source[data-src]');
        if (source && !source.hasAttribute('src')) {
          source.src = source.dataset.src;
          this.video.load();
        }
      };
      this.syncButton = () => {
        const playing = !this.video.paused;
        this.button.textContent = playing ? 'Pause' : 'Play';
        this.button.setAttribute('aria-pressed', String(playing));
        const name = this.video.getAttribute('aria-label');
        this.button.setAttribute('aria-label', `${playing ? 'Pause' : 'Play'} video: ${name}`);
      };
      this.update = () => {
        if (document.hidden || !this.inView || this.manualPaused || this.motion.matches) {
          this.video.pause();
        } else {
          this.load();
          this.video.play().catch(this.syncButton);
        }
      };
      this.onClick = () => {
        if (!this.video.paused) {
          this.manualPaused = true;
          this.video.pause();
        } else {
          this.manualPaused = false;
          this.load();
          this.video.play().catch(this.syncButton);
        }
      };
      this.onMotion = () => this.update();
      this.observer = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting;
        this.update();
      }, { threshold: 0.15 });
      this.button.addEventListener('click', this.onClick);
      this.video.addEventListener('play', this.syncButton);
      this.video.addEventListener('pause', this.syncButton);
      this.motion.addEventListener('change', this.onMotion);
      document.addEventListener('visibilitychange', this.update);
      this.observer.observe(this);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.video?.pause();
      this.button?.removeEventListener('click', this.onClick);
      this.video?.removeEventListener('play', this.syncButton);
      this.video?.removeEventListener('pause', this.syncButton);
      this.motion?.removeEventListener('change', this.onMotion);
      document.removeEventListener('visibilitychange', this.update);
    }
  });
})();
